export default __webpack_public_path__ + "static/media/mnemonic.33bebe1c.svg";